import { __extends, __rest, __assign } from 'tslib';
import React__default, { createRef } from 'react';
import clsx from 'clsx';
import SelectionList from '../SelectionList/SelectionList.component.js';
import { propTypes, defaultProps } from './SelectionMenu.types.js';
import styles from './SelectionMenu.module.scss.js';
import './SelectionMenu.scss.js';

var SelectionMenu = /** @class */ (function (_super) {
    __extends(SelectionMenu, _super);
    function SelectionMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.node = createRef();
        /**
         * When a mouse is clicked we want to do this:
         * - when we click on the menu we want it to behave normally
         * - when we click outside the menu we want to close it
         *
         * @param {Event} event - a DOM mouse down event
         */
        _this.handleMouseClick = function (event) {
            var _a;
            var _b = _this.props, isOpen = _b.isOpen, onRequestClose = _b.onRequestClose;
            if ((_a = _this.node.current) === null || _a === void 0 ? void 0 : _a.contains(event.target)) {
                return; // continue
            }
            // click happened outside of our element
            if (isOpen) {
                onRequestClose();
            }
        };
        return _this;
    }
    SelectionMenu.prototype.componentDidMount = function () {
        // add an event listener to this component to determine if/when a click
        // happens *outside* of the component
        document.addEventListener('mousedown', this.handleMouseClick, false);
    };
    SelectionMenu.prototype.componentWillUnmount = function () {
        // cleanup after ourselves
        document.removeEventListener('mousedown', this.handleMouseClick, false);
    };
    SelectionMenu.prototype.render = function () {
        var _a = this.props, menuPosition = _a.menuPosition, selectionListClassName = _a.selectionListClassName, className = _a.className, triggerElement = _a.triggerElement, isOpen = _a.isOpen, disabled = _a.disabled, SelectionListProps = __rest(_a, ["menuPosition", "selectionListClassName", "className", "triggerElement", "isOpen", "disabled"]);
        return (React__default.createElement("div", { ref: this.node, className: clsx(styles.Container, disabled && styles.Container___disabled, className) },
            React__default.createElement("div", { className: styles.Trigger }, triggerElement),
            React__default.createElement("div", { className: clsx(styles.SelectionMenu, isOpen && styles.SelectionMenu___open, styles['SelectionMenu___' + menuPosition]) },
                React__default.createElement(SelectionList, __assign({}, SelectionListProps, { className: clsx(styles.SelectionMenu_selectionList, selectionListClassName), labelClassName: styles.SelectionMenu_selectionList_label })))));
    };
    SelectionMenu.displayName = 'SelectionMenu';
    SelectionMenu.propTypes = propTypes;
    SelectionMenu.defaultProps = __assign({}, defaultProps);
    return SelectionMenu;
}(React__default.Component));

export { SelectionMenu as default };
